import type { Row, RowData } from '@tanstack/react-table';

import { Field as BaseField } from '@base-ui/react';
import { useTranslation } from 'react-i18next';

import type { AppTableFeatures } from './Table.hooks';

import { Checkbox } from '../Form/Checkbox/Checkbox';
import { useTableContext } from './TableRoot.context';

export const TableSelectAll = () => {
  const { getIsAllPageRowsSelected, getIsSomePageRowsSelected, getRowModel, toggleAllPageRowsSelected } = useTableContext();

  const { t } = useTranslation(['common']);

  if (!getRowModel().rows.some((row) => row.getCanSelect())) return null;

  return (
    <BaseField.Root>
      <Checkbox.Root
        aria-label={t('common:datatable.selection.selectAll')}
        checked={getIsAllPageRowsSelected()}
        indeterminate={getIsSomePageRowsSelected() && !getIsAllPageRowsSelected()}
        onCheckedChange={(checked) => toggleAllPageRowsSelected(checked)}
      />
    </BaseField.Root>
  );
};

export type TableSelectRowProps<TData extends RowData> = {
  row: Row<AppTableFeatures, TData>;
};

export const TableSelectRow = <TData extends RowData>({ row }: TableSelectRowProps<TData>) => {
  const { t } = useTranslation(['common']);

  if (!row.getCanSelect()) return null;

  return (
    <BaseField.Root>
      <Checkbox.Root
        aria-label={t('common:datatable.selection.selectRow')}
        checked={row.getIsSelected()}
        onCheckedChange={(checked) => row.toggleSelected(checked)}
      />
    </BaseField.Root>
  );
};
